export enum ServiceType {
  IOR = 'IOR',
  EOR = 'EOR',
  BOTH = 'Both',
}
